module.exports = __webpack_public_path__ + "static/img/case-kyj-page-bg-04.91a13ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/kyj/case-kyj-page-bg-04.png
// module id = uWlX
// module chunks = 1